import classNames from 'classnames'
import { ReactNode } from 'react'

interface ItemProps {
  classes?: string
  children: ReactNode
}

export const PageTitle = ({ classes, children }: ItemProps) => (
  <h2
    className={classNames(
      'jost-light text-[1.4rem] md:text-[1.5rem] md:leading-[2rem] lg:text-[1.65rem] lg:leading-[2.3rem] xl:text-[1.85rem] xl:leading-[2.6rem] 2xl:text-[2.15rem] 2xl:leading-[3rem] text-text-muted',
      classes
    )}
  >
    {children}
  </h2>
)
